import {Link} from "react-router-dom";
import {useI18n} from "@/components/shop/I18nProvider";

export function NotFoundPage() {
  const {t} = useI18n();
  return (
    <div className="textZone" style={{textAlign: "center", padding: "60px 20px"}}>
      <img src="/images/404.png" alt="404" style={{maxWidth: 320, margin: "0 auto 20px"}} />
      <h1 className="mainTitle wLine"><span>404</span></h1>
      <p>Pagina nu a fost gasita.</p>
      <p><Link to="/" className="buton anim">{t("Home")}</Link></p>
    </div>
  );
}
